import * as React from "react"
import {ButtonIconSeeker} from "@components/ui";
import {dsColorNew} from "@palette";


export default function ToolbarButton({ icon, iconWeight="regular", ...props }) {
	return <ButtonIconSeeker
		icon={icon}
		iconWeight={iconWeight}
		{...props}
		sx={{
			width: 32, height: 32,
			borderRadius: '8px',
			border: '1px solid rgba(0,0,0,0.08)',
			backgroundColor: '#fff',
			color: '#6B7280',
			boxShadow: 'none',
			'&:hover': { backgroundColor: '#F9FAFB', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', borderColor: 'rgba(0,0,0,0.12)' },
			...props?.sx
		}}
	/>
}